import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { CATALOG_CARD_WIDTH } from 'modules/template-editor/ui/components/catalog/catalog-card-metrics';
import { theme } from 'styles/theme/theme';

export const increaseClickArea = ({ width, height }: { width: number; height: number }) => {
  return css`
    position: relative;

    &:after {
      content: '';
      position: absolute;
      width: ${width}px;
      height: ${height}px;
    }
  `;
};

export const MainBlock = styled.div`
  padding-top: 60px;
  padding-inline: 24px;
  display: flex;
  height: 100%;
  padding-bottom: 30px;
`;

export const TemplateListCatalog = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, ${CATALOG_CARD_WIDTH}px);
  justify-content: space-between;
  /* Ряды — по высоте карточки, а не растянуты на свободное место: иначе позиция второго ряда зависит от числа
     карточек, и скелетон расходится с экраном (IMGM-1618). */
  align-content: start;
  grid-auto-flow: row;
  grid-row-gap: 20px;
  grid-column-gap: 20px;
  margin-top: 40px;

  padding-inline: 24px;
  padding-bottom: 8px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 6px;
    background-color: ${theme.colors.SurfaceCultured10};
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${theme.colors.DarkBlue100};
    border-radius: 8px;
  }
`;
